<template>
  <div>
    <div>
      <v-sheet>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-toolbar
              color="#0274b3"
              dark
              class="d-flex justify-center card-toolbar"
              width="200px"
              rounded
            >
              <h5 class="text-h5">Your Account</h5>
            </v-toolbar>

            <v-card class="mb-8" outlined color="#f5f5f5" elevation="10">
              <v-card-text class="body-2 black--text job-text">
                <div class="d-flex align-center mb-5">
                  <UpdateResume />

                  <div class="subtitle-1">
                    Current resume:
                    <div
                      v-if="
                        getUserData.applicants.length &&
                        getUserData.applicants[0].resume
                      "
                    >
                      <a
                        :href="getUserData.applicants[0].resume.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ getUserData.applicants[0].resume.hash }}</a
                      >
                    </div>
                    <span v-else>No Resume Uploaded</span>
                  </div>
                </div>

                <div class="d-flex align-center mb-5">
                  <UpdateEmail
                    :snackbarText="this.snackbarText"
                    :snackbar="this.snackbar"
                  />
                  <div class="subtitle-1">Email: {{ getUserData.email }}</div>
                </div>
                <div class="d-flex align-center mb-5">
                  <!-- <UpdatePassword /> -->
                  <v-btn
                    @click="handleSendForgottenPassword"
                    class="mr-5"
                    color="error"
                    width="85"
                    >Update</v-btn
                  >
                  <div class="subtitle-1">Password</div>
                </div>
                <div class="d-flex align-center">
                  <v-btn class="mr-5" color="error" width="85">Email</v-btn>
                  <div class="subtitle-1">
                    Contact
                    <a href="mailto:hireme@hirenextgeneration.com"
                      >hireme@hirenextgeneration.com</a
                    >
                    for any other matters.
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <div v-if="this.applicants.length">
              <v-toolbar
                color="#0274b3"
                dark
                class="d-flex justify-center card-toolbar"
                width="200px"
                rounded
              >
                <h5 class="text-h5">Your Feedback</h5>
              </v-toolbar>

              <v-card>
                <v-card-text
                  class="body-2 black--text job-text"
                  v-for="userApplicant in getUserData.applicants"
                  :key="userApplicant.id"
                >
                  <div v-if="userApplicant.job_post">
                    <div class="d-flex">
                      <h5 class="text-h5 font-weight-bold mb-5">
                        {{ userApplicant.job_post.position }}
                      </h5>
                      <h5 class="text-h6 mb-5 ml-2">
                        - Date Applied:
                        {{
                          formmatedDate(
                            userApplicant.dateApplied,
                            'MMMM d, yyyy'
                          )
                        }}
                      </h5>
                    </div>

                    <div v-if="userApplicant.showFeedback">
                      <div v-html="userApplicant.feedback"></div>
                    </div>
                    <div class="d-flex">
                      <ApplicantModal
                        :applicant="userApplicant"
                        videoButton="true"
                      />
                      <a :href="userApplicant.resume.url"
                        ><v-icon x-large>mdi-file-document</v-icon></a
                      >
                    </div>
                    <div class="d-inline-block mt-5 ml-2">
                      <Apply
                        mobileButtonText="Practice Again"
                        buttonText="Practice Again"
                        color="#FC4A46"
                        dark
                        :candidateId="getUserData.id"
                        :candidateFirstName="getUserData.firstName"
                        :candidateSurname="getUserData.surname"
                        :jobPostId="userApplicant.job_post.id"
                      />
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>

        <v-snackbar
          v-model="$store.state.candidate.snackbar"
          dark
          color="#0274b3"
          timeout="-1"
        >
          {{ $store.state.candidate.snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="
                $store.dispatch('HANDLE_SNACKBAR', {
                  snackbar: false,
                  snackBarText: '',
                })
              "
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-sheet>
    </div>
    <!-- <div v-else>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div> -->
  </div>
</template>

<script>
// import JobPostTeaser from '@/components/JobPostTeaser';
import UpdateEmail from '@/components/Auth/UpdateEmail';
import UpdateResume from '@/components/UpdateResume';
// import UpdateVideo from '@/components/UpdateVideo';
import { authComputed, formmatedDate } from '@/store/helpers';
// import { format } from 'date-fns';
import marked from 'marked';
import ApplicantModal from '@/components/CandidateReview/ApplicantModal';
import Apply from '@/components/Apply';

export default {
  components: {
    // JobPostTeaser,
    UpdateEmail,
    ApplicantModal,
    UpdateResume,
    Apply,
    // UpdateVideo,
  },
  data() {
    return {
      //user: this.$store.getters.getUserData,
      //applicants: this.$store.getters.getUserApplicants,
      //applicants: this.getUserData.applicants,
      resume: null,
      resumeId: null,
    };
  },

  // created() {
  //   this.$store.dispatch(
  //     'FETCH_DATA',
  //     this.$store.getters.getUserData.candidate.id
  //   );
  // },

  mounted() {
    this.$store.dispatch('FETCH_USER_APPLICANTS', {
      userId: this.$store.getters.getUserId,
    });
  },
  filters: {
    marked: marked,
  },
  computed: {
    ...authComputed,

    getFeedback() {
      return this.getCandidate.showFeedback ? this.getCandidate.feedback : '';
    },
    applicants() {
      return this.getUserData.applicants;
    },
  },

  methods: {
    compiledMarkdown: function (input) {
      return marked(input, { sanitize: true });
    },
    formmatedDate,

    showPasswordEmailSnackbar() {
      this.$store.dispatch('HANDLE_SNACKBAR', {
        snackbar: true,
        snackbarText:
          'An email has been sent to your inbox. Please follow the instructions to change your password.',
      });
    },

    sendEmail() {
      this.$store.dispatch('SEND_FORGOTTEN_PASSWORD', {
        email: this.$store.getters.getUserData.email,
      });
    },

    closeSnackbar() {
      console.log('closeSnackbar');
      this.$store.dispatch('HANDLE_SNACKBAR', {
        snackbar: false,
        snackBarText: '',
      });
    },

    handleSendForgottenPassword() {
      this.$store.dispatch('SEND_FORGOTTEN_PASSWORD', {
        email: this.$store.getters.getUserData.email,
      });
    },
  },
};
</script>

<style></style>
